/* eslint-disable no-nested-ternary */
import * as React from 'react';

declare let window: any;

const Reject = () => {
    const PURCHASE_REQUEST_DECLINED = 1;
    const PURCHASE_SELF_EXCLUSION = 2;

    const imgStyle = {
        width: '8em',
        paddingBottom: '2rem',
    };
    const boxStyle = {
        paddingTop: '5rem',
        paddingBottom: '5rem',
    };
    return (
        <div className="page text-center">
            <div className="form-container text-dark" style={boxStyle}>
                <img src="/images/warning.png" alt="warning" style={imgStyle} />
                <h3>Purchase request declined</h3>
                {window.purchaseError === PURCHASE_REQUEST_DECLINED ? (
                    <p>
                        For security reasons, the purchase you have tried to make cannot completed. Contact us{' '}
                        <a href="https://chumbacasino.zendesk.com/hc/en-us/requests/new">here</a> for further
                        assistance.
                    </p>
                ) : window.purchaseError === PURCHASE_SELF_EXCLUSION ? (
                    <div>
                        <p>
                            <strong>Thanks for Playing!</strong>
                            <br />
                            You have reached your limits for playing Chumba Casino.
                        </p>
                        <p>
                            If you would like to adjust these limits please contact customer support at{' '}
                            <a href="mailto:support@chumbacasino.com">
                                <em>support@chumbacasino.com</em>
                            </a>
                            .
                        </p>
                    </div>
                ) : (
                    <p>
                        The purchase you have tried to make cannot be completed. Contact us{' '}
                        <a href="https://chumbacasino.zendesk.com/hc/en-us/requests/new">here</a> for further
                        assistance.
                    </p>
                )}
            </div>
        </div>
    );
};

export default Reject;
